<template>
  <generic-crud :service='service' labelNome='nome_tag'></generic-crud>
</template>
<script>

import GenericCrud from '../components/GenericCrud'
import TagService from '../services/tag-service'

export default {

  components: {
    GenericCrud
  },
  data () {
    return {
      service: TagService
    }
  }
}
</script>

